import React, { lazy, Suspense } from "react";
import backgroundImg from "../images/BG-hands.webp";
import SearchBar from "../components/SearchBar";
import { CustomLink } from "../components/CustomLink";

const OrgCard = lazy(() => import("../components/OrgCard"));
const LazyFooter = lazy(() => import("../components/Footer"));
const LazyHeader = lazy(() => import("../components/Header"));

const CharitysubCategorylist = ({ pageContext, location }) => {
  const category = pageContext?.subcategory;
  let sortedCards = category?.charities;
  const categories = category?.categories;
  const isDataLoad = true;
  const mainCategory = pageContext?.mainCategory;

  const compareRevenue = (a, b) => {
    // Remove the dollar sign and commas from the revenue strings
    const revenueA = Number(a.crtorev?.replace(/[$,]/g, ""));
    const revenueB = Number(b.crtorev?.replace(/[$,]/g, ""));
    // Compare the revenue values in descending order
    return revenueB - revenueA;
  };

  sortedCards = sortedCards.sort(compareRevenue);

  const charitiesTitleSplit = category?.title.split(" ");
  const firstPart = charitiesTitleSplit?.slice(0, 1);
  const secondPart =
    charitiesTitleSplit?.length > 2
      ? charitiesTitleSplit?.slice(1, 2)
      : charitiesTitleSplit?.slice(1);
  const thirdPart =
    charitiesTitleSplit?.length > 2 && charitiesTitleSplit.slice(2);
  const mergeTitle =
    charitiesTitleSplit?.length > 2
      ? firstPart
          ?.concat(` ${  secondPart}`)
          ?.concat(" ")
          ?.concat(thirdPart)
          ?.join("")
      : firstPart?.includes("Medium")
      ? firstPart?.concat("-sized ")?.concat(secondPart)?.join("")
      : firstPart?.concat(secondPart)?.join(" ");
  
  const numberWithCommas = category?.count?.toLocaleString("en-US");
  const topLen = category?.count < 10 ? category?.count : 10;
  return (
    <Suspense fallback={<div />}>
      {isDataLoad &&
      <div>
        <LazyHeader/>
        <main>
          {/* w-full bg-index px-7 pt-10 pb-[30px] lg:px-35 xl:px-30 2xl:px-44 lg:pt-[60px] */}
          <div
            className="w-full px-7  pb-[30px] pt-10 lg:px-2 lg:pt-[60px] xl:px-28 2xl:px-32 "
            style={{
              backgroundImage: `url(${backgroundImg})`,
              backgroundSize: "cover"
            }}
          >
            <h1 className=" text-center text-2xl font-bold lg:text-5xl">
              {mainCategory
                ? <span> There {
                    numberWithCommas === 1 ? "is" : "are"
                  } {numberWithCommas} <span  className="capitalize"> {category?.title}</span> {
                    numberWithCommas === 1 ? "Nonprofit" : "Nonprofits"
                  }</span>
                : <span> <span className="capitalize">{mergeTitle} </span> by Revenue </span> }
            </h1>

            <div className="mt-7 ">
              <SearchBar/>
              <div className="mt-7">
                { sortedCards.length > 0 &&
                <h2 className="text-center text-xl font-semibold lg:text-4xl">
                
                  Here are {mainCategory ? ` the ${topLen} Largest ` : ` ${topLen} `}
                  {mainCategory ? (
                    <span className="capitalize">
                      {category?.title} Nonprofits
                    </span>
                  ) : (
                    <span>
                      Popular <span className="capitalize">{mergeTitle}</span>
                    </span>
                  )}                
                </h2>
              }
              </div>
              <div className="">
                <div className="mt-[30px] grid gap-7 md:grid-cols-2 lg:mt-[60px] lg:grid-cols-3">
                  {sortedCards?.slice(0, 10)?.map((item, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <OrgCard data={item} key={index} location={location} />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className=" my-2 bg-white p-7  lg:px-28 xl:px-28 2xl:px-32 ">
            <div className="">
              <h2 className="mt-[10px] pb-4  text-center text-xl font-medium text-[#4D4D4D] lg:mt-7 lg:text-4xl">
                {mainCategory ? (
                  <span>
                    Find All {numberWithCommas}{" "}
                    <span className="capitalize">
                      {category?.title }{" "} 
                    </span>
                    Nonprofits by Name
                  </span>
                ) : (
                  <span>
                    Find All {numberWithCommas}{" "}
                    <span className="capitalize">
                      {mergeTitle}{" "} 
                    </span>
                    by Name
                  </span>
                )}
                {/* Search by alphabet */}
              </h2>

              <div
                className="bg-[#88d8b540] p-2"
                style={{ boxShadow: "0px 8px 40px 0px rgba(0, 0, 0, 0.10)" }}
              >
                <ul>
                  {
                    categories.map((category) => (
                      <CustomLink href={category.url}>
                        <li>
                          <div className="my-2 flex cursor-pointer justify-start  rounded-[7px] bg-white  p-2 text-xl font-medium">
                            <span className="ml-2 text-[#0D82EE] "> { category.name } </span>
                          </div>
                        </li>
                      </CustomLink>
                    ))                    
                  }
                </ul>
              </div>
            </div>
          </div>
          <div className="flex   flex-col-reverse px-7 md:flex-row  md:justify-between lg:px-28 xl:px-28 2xl:px-32 ">
            <CustomLink href="/" className="flex  justify-center md:justify-start">
              <button className="flex justify-center rounded-lg  bg-primary p-4 text-lg  font-semibold  shadow-[0px_4px_10px_0px_#00000026]" type="button">
                EXPLORE OTHER CHARITIES
              </button>
            </CustomLink>
          </div>
        </main>
        <LazyFooter/>
      </div>
}
    </Suspense>
  );
};
export default CharitysubCategorylist;

export const Head = ({pageContext}) =>
  <>
    <title>{pageContext.subcategory.pgTitle}</title>
    <meta name="description" content={ pageContext?.mainCategory ? `Find all ${pageContext?.subcategory?.title.toLowerCase()} nonprofits by alphabetical list or search for them.`.replace("medium", "medium-sized") : `The top 10 most popular ${pageContext.subcategory.title.toLowerCase()} - search for all ${pageContext.subcategory.title.toLowerCase()}.`.replace("medium", "medium-sized")}/>
  </>
